module.exports = "/packs/cancel_lesson_banner_sp-0658df55b64c17cb9948bc04c958327c.png";